import { RegisterPayload } from 'models/endpoints-payload'
import { RegisterResponse } from 'models/endpoints-respone'

import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_IK: string

export const registerUser = (payload: RegisterPayload): Promise<RegisterResponse> => {
  return promiseWrapper<RegisterResponse, RegisterPayload>(
    `${USER_BASE_URL_IK}/api/public/registration`,
    'POST',
    payload,
    {
      withCredentials: true,
    },
  )
}
